import { Injectable } from '@angular/core';
import { LocalStorageHelper } from '../helper/local-storage-helper';
import { IconsConstants, RoutesConstants, SharedConstants } from '../common';
import { SideMenuItem } from '../interfaces';
import { Permissions } from 'src/app/core/common';
import { UserPermissionService } from 'src/app/core/services/user-permission-service';
import { NESTED_PERMISSIONS } from '../common/nested-permissions';
import { BehaviorSubject, Observable } from 'rxjs';
import { AllPermissionsKeys } from 'src/app/core/common/all-permissions-keys.enum';

@Injectable({
  providedIn: 'root',
})
export class NavBarService {
  isCollapsed$: Observable<boolean>;
  private isSideNavCollapsed$ = new BehaviorSubject<boolean>(false);

  //getters
  get isSideNavCollapsed(): boolean {
    return this.isSideNavCollapsed$.value;
  }

  //constants
  IconsConstants = IconsConstants;

  constructor(private userPermissionService: UserPermissionService) {
    this.isCollapsed$ = this.isSideNavCollapsed$.asObservable();
    this.getSideNavStatusFromLocalStorage();
  }

  // publics
  toggleSideNavBar(): void {
    this.isSideNavCollapsed$.next(!this.isSideNavCollapsed);
    LocalStorageHelper.setItem(SharedConstants.NAV_BAR_IS_COLLAPSED, this.isSideNavCollapsed);
  }

  closeSideNavBar(): void {
    this.isSideNavCollapsed$.next(true);
    LocalStorageHelper.setItem(SharedConstants.NAV_BAR_IS_COLLAPSED, this.isSideNavCollapsed);
  }

  getSideNavItems(): SideMenuItem[] {
    return [
      {
        translationTextKey: 'DASHBOARD',
        isVisible: this.userPermissionService.isHasPermission(NESTED_PERMISSIONS.get(AllPermissionsKeys.HomePage)),
        icon: IconsConstants.DASHBOARD_ICON,
        children: [
          {
            translationTextKey: 'GRAPHS1',
            isVisible: this.userPermissionService.isHasPermission([
              Permissions.HomePage_CALLS_REPORT_CHART,
              Permissions.HomePage_OnLineStudent_Chart,
              Permissions.HomePage_OnLineTeacher_Chart,
            ]),
            icon: IconsConstants.MENU_ICON,
            routerLink: RoutesConstants.DASHBOARD_PAGE_URL,
          },
          /*  {
            translationTextKey: 'GRAPHS2',
            isVisible: this.userPermissionService.isHasPermission(NESTED_PERMISSIONS.get(Permissions.HomePage)),
            routerLink: RoutesConstants.DASHBOARD_PAGE_BALANCE_MINUTES_URL,
          }, */
          // {
          //   translationTextKey: 'GRAPHS3',
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.HomePage_PEAKTIME_Report_Chart]),
          //   routerLink: RoutesConstants.DASHBOARD_PAGE_PEAK_URL,
          //   icon: IconsConstants.MENU_ICON,
          // },
        ],
      },
      {
        translationTextKey: 'STATISTICS',
        isVisible: this.userPermissionService.isHasPermission([Permissions.Statistics]),
        icon: IconsConstants.STATUS_UP_ICON,
        routerLink: RoutesConstants.DASHBOARD_WL_PAGE_URL,
      },
      // {
      //   translationTextKey: 'FATIHA_REQUESTS',
      //   isVisible: this.userPermissionService.isHasPermission(NESTED_PERMISSIONS.get(AllPermissionsKeys.Fatiha)),
      //   icon: IconsConstants.NOTEBOOK_ICON,
      //   routerLink: RoutesConstants.FATIHA_REQUESTS_PAGE_URL,
      // },
      {
        translationTextKey: 'CONTACT_US',
        isVisible: this.userPermissionService.isHasPermission([
          Permissions.HomePage_Teacher_Message,
          Permissions.HomePage_Student_Message,
        ]),
        icon: IconsConstants.HEADPHONES_ICON,
        routerLink: RoutesConstants.CUSTOMER_SUPPOR_REPORT_PAGE_URL,
      },
      {
        translationTextKey: 'UPLOAD_FILES',
        icon: IconsConstants.FOLDER_ADD_ICON,
        isVisible: this.userPermissionService.isHasPermission(NESTED_PERMISSIONS.get(AllPermissionsKeys.BulkUpload)),
        children: [
          {
            translationTextKey: 'UPLOAD_TEACHERS_FILES',
            icon: IconsConstants.MENU_ICON,
            routerLink: RoutesConstants.UPLOAD_TEACHERS_FILES,
            isVisible: this.userPermissionService.isHasPermission([Permissions.UploadDate_Teacher]),
          },
          // {
          //   translationTextKey: 'UPLOAD_STUDENTS_FILES',
          //   icon: IconsConstants.MENU_ICON,
          //   routerLink: RoutesConstants.UPLOAD_STUDENTS_FILES,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.UploadDate_Student]),
          // },
          // {
          //   translationTextKey: 'UPLOAD_STUDENTS_PLANS_FILES',
          //   icon: IconsConstants.MENU_ICON,
          //   routerLink: RoutesConstants.UPLOAD_STUDENTS_PLANS_FILES,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.UploadDate_Student_Plan]),
          // },
          // {
          //   translationTextKey: 'UPLOAD_UPDATE_STUDENTS_FILES',
          //   icon: IconsConstants.MENU_ICON,
          //   routerLink: RoutesConstants.UPLOAD_UPDATE_STUDENTS_FILES,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.UploadDate_Update_Student]),
          // },
        ],
      },
      {
        translationTextKey: 'REPORTS',
        isVisible: this.userPermissionService.isHasPermission(NESTED_PERMISSIONS.get(AllPermissionsKeys.Reports)),
        icon: IconsConstants.CHART_ICON,
        children: [
          {
            translationTextKey: 'REPORTS-TEACHERS',
            routerLink: RoutesConstants.TEACHERS_REPORT_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Teacher]),
            icon: IconsConstants.MENU_ICON,
          },
          {
            translationTextKey: 'REPORT_STUDENTS',
            routerLink: RoutesConstants.STUDENTS_REPORT_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Student]),
            icon: IconsConstants.MENU_ICON,
          },
          // {
          //   translationTextKey: 'CALLS_REPORT',
          //   routerLink: RoutesConstants.CALLS_REPORT_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Call]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          // {
          //   translationTextKey: 'CALLS_DETAILS_REPORT',
          //   routerLink: RoutesConstants.CALLS_DETAILS_REPORT_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Detailed_Call]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          // {
          //   translationTextKey: 'BLOCKED_STUDENTS_REPORT',
          //   routerLink: RoutesConstants.BLOCKED_STUDENTS_REPORT_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Blocked_Student]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          {
            translationTextKey: 'TEACHERS_PERFORMANCE_REPORTS',
            routerLink: RoutesConstants.TEACHERS_PERFORMANCE_REPORT_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Performance_Teacher]),
            icon: IconsConstants.MENU_ICON,
          },
          {
            translationTextKey: 'STUDENT_PERFORMANCE_REPORTS',
            routerLink: RoutesConstants.STUDENT_PERFORMANCE_REPORT_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Performance_Student]),
            icon: IconsConstants.MENU_ICON,
          },
          // {
          //   translationTextKey: 'DEPENDENTS_REPORTS',
          //   routerLink: RoutesConstants.DEPENDENTS_REPORT_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Dependent]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          {
            translationTextKey: 'REVIEWS_REPORTS',
            routerLink: RoutesConstants.REVIEWS_REPORT_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([
              Permissions.Reports_Reviews,
              Permissions.User_Management_Admin_Users_Customer_Service,
            ]),
            icon: IconsConstants.MENU_ICON,
          },
          // {
          //   translationTextKey: 'REVIEWERS_REVIEWS_REPORTS',
          //   routerLink: RoutesConstants.REVIEWERS_REVIEWS_REPORT_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Admin_Reviews]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          {
            translationTextKey: 'BALANCE_REPORT',
            routerLink: RoutesConstants.BALANCE_REPORT_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Student_Packages]),
            icon: IconsConstants.MENU_ICON,
          },
          {
            translationTextKey: 'SESSIONS_REPORT',
            routerLink: RoutesConstants.SESSIONS_REPORT_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Sessions]),
            icon: IconsConstants.MENU_ICON,
          },
          // {
          //   translationTextKey: 'TEACHER_ONLINE_MINUTES_REPORT',
          //   routerLink: RoutesConstants.TEACHER_ONLINE_MINUTES_REPORT_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_OnlineMinutes_Teacher]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          // {
          //   translationTextKey: 'PEAK_HOURS_REPORT',
          //   routerLink: RoutesConstants.PEAK_HOURS_REPORT_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_PeakTime]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          {
            translationTextKey: 'MESSAGES_REPORT',
            routerLink: RoutesConstants.MESSAGES_REPORT_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_NotificationReport]),
            icon: IconsConstants.MENU_ICON,
          },
          {
            translationTextKey: 'RESERVATIONS_REPORT',
            routerLink: RoutesConstants.RESERVATIONS_REPORT_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Reservation]),
            icon: IconsConstants.MENU_ICON,
          },
          // {
          //   translationTextKey: 'PAY_TABS_REPORT',
          //   routerLink: RoutesConstants.PAY_TABS_REPORT_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_PaymentTransaction]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          // {
          //   translationTextKey: 'SURVEYS_REPORT',
          //   routerLink: RoutesConstants.SURVEYS_REPORT_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Survey]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          // {
          //   translationTextKey: 'STORE_RATINGS_REPORT',
          //   routerLink: RoutesConstants.STORE_RATINGS_REPORT_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_App_Rating]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          {
            translationTextKey: 'STUDENT_DETAILS_REPORT',
            routerLink: RoutesConstants.STUDENT_DETAILS_REPORT_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Student_Info]),
            icon: IconsConstants.MENU_ICON,
          },
          // {
          //   translationTextKey: 'DONATIONS',
          //   routerLink: RoutesConstants.DONATIONS_REPORT_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Donations]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          // {
          //   translationTextKey: 'BENEFICIARIES_REPORT',
          //   routerLink: RoutesConstants.BENEFICIARIES_REPORT_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Beneficiaries]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          // {
          //   translationTextKey: 'STUDENTS_PLANS_REPORT',
          //   routerLink: RoutesConstants.STUDENTS_PLANS_REPORT_PAGE_URL,
          //   icon: IconsConstants.MENU_ICON,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Student_Plans]),
          // },
          {
            translationTextKey: 'TEACHERS_PLANS_REPORT',
            routerLink: RoutesConstants.TEACHERS_PLANS_REPORT_PAGE_URL,
            icon: IconsConstants.MENU_ICON,
            isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Teachers_plans]),
          },
          // {
          //   translationTextKey: 'TOTAL_DURATION_REPORT',
          //   routerLink: RoutesConstants.TOTAL_DURATION_REPORT_PAGE_URL,
          //   icon: IconsConstants.MENU_ICON,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Total_Duration]),
          // },
          {
            translationTextKey: 'TEACHER_RESERVATION_REPORT',
            routerLink: RoutesConstants.TEACHER_RESERVATION_REPORT_PAGE_URL,
            icon: IconsConstants.MENU_ICON,
            isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Teacher_Reservation]),
          },
          // {
          //   translationTextKey: 'FREE_CODES_REPORT',
          //   routerLink: RoutesConstants.FREE_CODES_REPORT_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_Free_codes]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          // {
          //   translationTextKey: 'FATIHA_SESSIONS',
          //   routerLink: RoutesConstants.FATIHA_SESSIONS_REPORT_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Fatiha_Sessions]),
          //   icon: IconsConstants.MENU_ICON,
          // },
        ],
      },
      //extract reports
      {
        translationTextKey: 'EXTRACT_REPORTS',
        icon: IconsConstants.DOCUMENT_DOWNLOAD_ICON,
        isVisible: this.userPermissionService.isHasPermission(
          NESTED_PERMISSIONS.get(AllPermissionsKeys.ExportedReports)
        ),
        routerLink: RoutesConstants.EXPORT_REPORTS_PAGE_URL,
      },
      // sessions
      // {
      //   translationTextKey: 'SESSION',
      //   icon: IconsConstants.VIDEO_ICON,
      //   routerLink: RoutesConstants.SESSIONS_PAGE_URL,
      //   isVisible: this.userPermissionService.isHasPermission(NESTED_PERMISSIONS.get(AllPermissionsKeys.Sessions)),
      // },
      // Manage users accounts
      {
        translationTextKey: 'MANAGE_USERS_ACCOUNTS',
        icon: IconsConstants.USER_PROFILE_ICON,
        isVisible: this.userPermissionService.isHasPermission(
          NESTED_PERMISSIONS.get(AllPermissionsKeys.UserManagement)
        ),
        children: [
          {
            translationTextKey: 'TEACHERS_UPDATE_INFO',
            routerLink: RoutesConstants.UPDATE_TEACHERS_INFO_REQUESTS_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([
              Permissions.User_Management_Update_Teacher_Request_Info,
            ]),
            icon: IconsConstants.MENU_ICON,
          },
          {
            translationTextKey: 'PERMISSIONS',
            routerLink: RoutesConstants.USERS_PERMISSIONS_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.User_Management_Admin_Users]),
            icon: IconsConstants.MENU_ICON,
          },
          // {
          //   translationTextKey: 'USERS_REPORTS',
          //   routerLink: RoutesConstants.USERS_REPORTS_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([
          //     Permissions.User_Management_Report_Student,
          //     Permissions.User_Management_Report_Teacher,
          //   ]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          // {
          //   translationTextKey: 'STUDENT_JOIN_US_REQUEST',
          //   routerLink: RoutesConstants.STUDENT_JOIN_US_REQUEST_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.User_Management_Student_Join_US]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          /*  {
            translationTextKey: 'TEACHER_JOIN_US',
            routerLink: RoutesConstants.TEACHER_JOIN_REQUEST_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.User_Management_Teacher_Join_US])
          }, */
          {
            translationTextKey: 'STUDENTS_MANAGEMENT',
            routerLink: RoutesConstants.STUDENT_ACCOUNT_MANAGEMENT_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([
              Permissions.User_Management_View_Student_Dependents,
              Permissions.User_Management_Disable_Student_Reservation,
              Permissions.User_Management_Disable_Student_Account,
              Permissions.User_Management_Disable_Student_Buy,
              Permissions.User_Management_Disable_Student_Call,
              Permissions.User_Management_Student_Disable_Recording,
              Permissions.User_Management_Student_Category,
              Permissions.USER_MANAGEMENT_SET_TEMP_PASSWORD,
              Permissions.USER_MANAGEMENT_VIEW_DEVICE_INFO,
            ]),
            icon: IconsConstants.MENU_ICON,
          },
          {
            translationTextKey: 'STUDENT_PACKAGES',
            routerLink: RoutesConstants.STUDENT_PACKAGES_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.User_Management_Student_Packages]),
            icon: IconsConstants.MENU_ICON,
          },
          // {
          //   translationTextKey: 'UPGRADE_STUDENTS_REQUESTS',
          //   routerLink: RoutesConstants.UPGRADE_STUDENTS_REQUESTS_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([
          //     Permissions.User_Management_Upgrade_Students_Request,
          //     Permissions.User_Management_Upgrade_DependentManager_Requests,
          //   ]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          {
            translationTextKey: 'TEACHERS',
            routerLink: RoutesConstants.TEACHERS_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([
              Permissions.User_Management_Reset_Rating_teacher,
              Permissions.User_Management_Reset_Balance,
              Permissions.User_Management_Disable_Teacher_Account,
              Permissions.User_Management_Teacher_Category,
              Permissions.User_Management_Disable_Student_Reservation,
            ]),
            icon: IconsConstants.MENU_ICON,
          },
          {
            translationTextKey: 'CONSULTANT_BALANCE',
            routerLink: RoutesConstants.CONSULTANT_BALANCE_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.User_Management_Teacher_Receivables]),
            icon: IconsConstants.MENU_ICON,
          },
          // {
          //   translationTextKey: 'BENEFICIARIES',
          //   routerLink: RoutesConstants.BENEFICIARIES_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.User_Management_Beneficiaries]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          /* {
            translationTextKey: 'RECEIVABLES',
            routerLink: RoutesConstants.RECEIVABLES_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.User_Management_Teacher_Receivables])
          } */
        ],
      },
      // control settings
      {
        translationTextKey: 'CONTROL_SETTINGS',
        icon: IconsConstants.SETTINGS_ICON,
        isVisible: this.userPermissionService.isHasPermission(NESTED_PERMISSIONS.get(AllPermissionsKeys.Setting)),
        children: [
          {
            translationTextKey: 'SYSTEM_CONFIGURATION',
            routerLink: RoutesConstants.GENERAL_CONFIGURATIONS_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.Setting_General]),
            icon: IconsConstants.MENU_ICON,
          },
          // {
          //   translationTextKey: 'ADD_MINUTES',
          //   routerLink: RoutesConstants.ADD_MINUTES_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Setting_Add_Student_Package]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          {
            translationTextKey: 'DISCOUNT_CODES',
            routerLink: RoutesConstants.DISCOUNT_CODES_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.Setting_Add_Promo]),
            icon: IconsConstants.MENU_ICON,
          },
          // {
          //   translationTextKey: 'FREE_CODES',
          //   routerLink: RoutesConstants.GET_FREE_CODES_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Setting_Add_Promo]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          {
            translationTextKey: 'CATEGORIES',
            routerLink: RoutesConstants.CATEGORIES_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.Setting_Category]),
            icon: IconsConstants.MENU_ICON,
          },
          // {
          //   translationTextKey: 'LINKS',
          //   routerLink: RoutesConstants.DYNAMIC_LINKS_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Setting_Dynamic_Link]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          {
            translationTextKey: 'ADS',
            routerLink: RoutesConstants.ADS_PAGE_URL,
            isVisible: this.userPermissionService.isHasPermission([Permissions.Setting_Banner]),
            icon: IconsConstants.MENU_ICON,
          },

          // {
          //   translationTextKey: 'PEAK_HOURS',
          //   routerLink: RoutesConstants.PEAK_HOURS_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Setting_Peak_Hour]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          // {
          //   translationTextKey: 'CALL_SHARED_FILES',
          //   routerLink: RoutesConstants.CALL_SHARED_FILES_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Setting_Call_Shared_Files]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          // {
          //   translationTextKey: 'FAQ_CATEGORIES',
          //   routerLink: RoutesConstants.FAQ_CATEGORIES_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Setting_Help_Categories]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          // {
          //   translationTextKey: 'FAQ',
          //   routerLink: RoutesConstants.FAQ_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Setting_Help_FAQs]),
          //   icon: IconsConstants.MENU_ICON,
          // },
          // {
          //   translationTextKey: 'SCHEDULED_NOTIFICATIONS',
          //   routerLink: RoutesConstants.SCHEDULED_NOTIFICATIONS_PAGE_URL,
          //   isVisible: this.userPermissionService.isHasPermission([Permissions.Reports_NotificationReport]),
          //   icon: IconsConstants.MENU_ICON,
          // },
        ],
      },
      // marketplace
      // {
      //   translationTextKey: 'STORE',
      //   icon: IconsConstants.BOX_ICON,
      //   isVisible: this.userPermissionService.isHasPermission(NESTED_PERMISSIONS.get(AllPermissionsKeys.Marketplace)),
      //   children: [
      //     {
      //       translationTextKey: 'PACKAGES',
      //       routerLink: RoutesConstants.MARKETPLACE_PACKAGES_PAGE_URL,
      //       isVisible: this.userPermissionService.isHasPermission([Permissions.Setting_Package]),
      //       icon: IconsConstants.MENU_ICON,
      //     },
      //     {
      //       translationTextKey: 'PRODUCTS',
      //       routerLink: RoutesConstants.MARKETPLACE_PRODUCTS_PAGE_URL,
      //       isVisible: this.userPermissionService.isHasPermission([Permissions.Setting_Products]),
      //       icon: IconsConstants.MENU_ICON,
      //     },
      //   ],
      // },
      //send msg
      {
        translationTextKey: 'SEND_MESSAGE',
        icon: IconsConstants.MESSAGE_ICON,
        isVisible: this.userPermissionService.isHasPermission([Permissions.HomePage_SendMessage]),
        routerLink: RoutesConstants.SEND_MESSAGE,
      },
      //add new teacher
      {
        translationTextKey: 'ADD_NEW_TEACHER',
        icon: IconsConstants.ADD_SQUARE_ICON,
        isVisible: this.userPermissionService.isHasPermission([Permissions.HomePage_AddTeacher]),
        routerLink: RoutesConstants.ADD_NEW_TEACHER_PAGE_URL,
      },
    ];
  }

  // privates
  private getSideNavStatusFromLocalStorage(): void {
    if (LocalStorageHelper.getItem(SharedConstants.NAV_BAR_IS_COLLAPSED) != null) {
      this.isSideNavCollapsed$.next(LocalStorageHelper.getItem(SharedConstants.NAV_BAR_IS_COLLAPSED) === 'true');
    } else {
      this.isSideNavCollapsed$.next(true);
    }
  }
}
